import { apiClient, APIResponse, extractApiError } from './api';


export const annualCalendarAPI = {
  async get({ year }) {
    try {
      const { data } = await apiClient.get(`/annual-calendar/?year=${year}`);
      return APIResponse.success(data);
    } catch (error) {
      return APIResponse.error(
        extractApiError(error, 'Não foi possível carregar o calendário anual.'),
      );
    }
  },
};
